import { render, staticRenderFns } from "./BetterKolmar.vue?vue&type=template&id=1674acdc"
import script from "./BetterKolmar.ts?vue&type=script&lang=ts&external"
export * from "./BetterKolmar.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports